import { render, staticRenderFns } from "./PanelDashboardDetailDialog.vue?vue&type=template&id=0b812308"
import script from "./PanelDashboardDetailDialog.vue?vue&type=script&lang=ts"
export * from "./PanelDashboardDetailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports